// Quantity Selector

document.querySelector('.plus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);
  document.querySelector('#qty').value = currentValue + 1;
});

document.querySelector('.minus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);

  if (currentValue > 1) {
    document.querySelector('#qty').value = currentValue - 1;
  }
});

// Product Slider - Thumbsnails

document.addEventListener("DOMContentLoaded", function () {

  var main = new Splide( '#main-carousel', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
  });

  var thumbnails = new Splide( '#thumbnail-carousel', {
    gap: 30,
    perPage: 3,
    rewind: true,
    pagination: false,
    isNavigation: true,
    breakpoints: {
      600: {
        perPage: 2,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
  
});

// Product Slider - Auto Height

document.addEventListener("DOMContentLoaded", function () {
  var slider = new window.Splide('#product-carousel', { 
    arrows: true, 
    pagination: false, 
    type: "loop",
  });
  var heightMap = {};
  document.querySelectorAll("#product-carousel .splide__slide").forEach(function (e) {
      e.style.maxHeight = 0;
  });
  slider.on("mounted", function () {
      var i = 0;
      document.querySelectorAll("#product-carousel .splide__slide").forEach(function (e) {
          if (!e.classList.contains('splide__slide--clone')) {
            heightMap[i] = e.scrollHeight;
            i++
          }
      });
    });
    slider.on("active", function (e) {
        // Or index if not loop
        // var maxHeight = heightMap[e.index] + "px";
        var maxHeight = heightMap[e.slideIndex] + "px";
        e.slide.style.maxHeight = maxHeight;
        e.slide.parentElement.style.maxHeight = maxHeight;
    });
    slider.mount();
});

// Slider Image Change when Colour Swatch has been clicked

document.querySelectorAll('.color-swatch input').forEach(c => {
  c.addEventListener('click', () => {
    let img = c.getAttribute('img');
    console.log("clicked");

    document.querySelectorAll('#thumbnail-carousel-track li').forEach(t => {

      slide = t.getAttribute('color');

      if (slide === img) {
        console.log("clicked thumb");
        t.click();      
      }

    });

  });
});

document.querySelectorAll('.color-swatch input').forEach(cs => {
  cs.addEventListener('click', () => {
    let img = cs.getAttribute('img');

    document.querySelectorAll('#product-carousel-list li').forEach(t => {

      slide = t.getAttribute('color');

      if (slide === img) {
        t.closest("li").click();      
      }

    });

  });
});

// Accordion

var acc = document.querySelectorAll(".accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
  
    // Loop over all the panels an close each one
    document.querySelectorAll(".panel").forEach(function(panel){
      panel.style.maxHeight = "0";
      panel.previousElementSibling.classList.remove("active");
    });
  
    // Then show the clicked panel
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.style.maxHeight = panel.scrollHeight + "px";

  });
}
// First always open
  // document.addEventListener( 'DOMContentLoaded', function () {
  //   acc[0].click();
  // });


